import { createFileRoute } from '@tanstack/react-router';
import { RelatorioFinanceiroRelacaoBoletos } from '@/features/relatorio/page/financeiro/relacao-boletos/RelatorioFinanceiroRelacaoBoletos';

export const Route = createFileRoute('/a/relatorio/financeiro/relacao-boletos')({
    component: RelatorioFinanceiroRelacaoBoletos,
});
